import React, { Component } from "react";
import { Container, Header, Footer, Card } from '@deere/ux.uxframe-react';
import CompanyTopHeader from './company-top-header';
import DiversityComponent from '../../diversity-finacial/diversity-component';
import FinacialComponent from '../../diversity-finacial/finacial-component';
import CommoditiesComponent from '../../commodities-services/components/commodities-component';
import Button from "../../reusable/components/Button.jsx";
import CompanyStatus from "./company-status";
import ServiceDownError from "../../reusable/components/ServiceDownError";
import baseurl from '../../api-properties';
import { isMobile } from 'react-device-detect';
import { getAuthToken } from "../../reusable/basic-auth-creds";

if (isMobile) {
    import('../../mobileindex.css').then(() => {});    
} else {
    import('../../index.css').then(() => {});
}

class SupplierApplicationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            render: false,
            readOnlySubmitBtn: true,
            prosNumber: this.props.match.params.value,
            prosSuppId: 0,
            companyInfo: [],
            displayDiversityInfoJson: false,
            diversityInfoJson: [],
            displayFinacialInfoJson: false,
            finacialInfoJson: [],
            displayCommoditiesInfoJson: false,
            commoditiesInfoJson: [],
            headerComment: "",
            isSupplierServiceDown: true,
            isCommodityServiceDown: true,
            isFinancialServiceDown: true,
            isDiversityServiceDown: true
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setRenderData = this.setRenderData.bind(this);
    }
    componentDidMount() {
        let prosNumber = this.state.prosNumber;
        this.loadSupplierDetails(prosNumber);
    }

    loadSupplierDetails = (prosNumber) => {
        // console.log("====================================================");
        // console.log("token: " + getAuthToken());
        // console.log("====================================================");

        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getSupplier/" + prosNumber + "/NULL", {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isSupplierServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data !== null) {
                    this.state.isSupplierServiceDown = false;
                    this.setState({ companyInfo: data });
                    if (data.diverseCert !== undefined && data.diverseCert != null && data.diverseCert !== "")
                        this.setState({ displayDiversityInfoJson: true });
                    this.setState({ prosSuppId: this.state.companyInfo.prosSuppId });
                    this.loadDiversityInfo(this.state.companyInfo.prosSuppId);
                }
            }).catch(error => {
                this.state.isSupplierServiceDown = false;
                console.log("GET Supplier Call");
                console.log(error);
            });
    }

    loadDiversityInfo = (prosSuppId) => {
        fetch(baseurl.DIVERSITY_API_URL + "diversity/getCertifications/" + prosSuppId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isDiversityServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null)
                    this.setState({ diversityInfoJson: data });
                this.state.isDiversityServiceDown = false;
                this.loadFinacialInfo(prosSuppId);
            }).catch(error => {
                this.state.isDiversityServiceDown = false;
                console.log(error);
            });
    }

    loadFinacialInfo = (prosSuppId) => {
        fetch(baseurl.FINACIAL_API_URL + "financial/getFinancial/" + prosSuppId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization" : "Basic " + getAuthToken()
            }
        }).then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isFinancialServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null && data.isDataExist === true)
                    this.setState({ displayFinacialInfoJson: true, finacialInfoJson: data });
                this.state.isFinancialServiceDown = false;
                this.loadCommoditiesInfo(prosSuppId);
            }).catch(error => {
                this.state.isFinancialServiceDown = false;
                console.log(error);
            });
    }

    loadCommoditiesInfo = (prosSuppId) => {
        fetch(baseurl.COMMODITY_API_URL + "commodity/getCommodity/" + prosSuppId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isCommodityServiceDown = false;
                    this.setRenderData();
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null && data.length > 0)
                    this.setState({ displayCommoditiesInfoJson: true, commoditiesInfoJson: data });
                this.state.isCommodityServiceDown = false;
                this.setRenderData();
                this.getHeaderComment();
            }).catch(error => {
                this.state.isCommodityServiceDown = false;
                this.setRenderData();
                console.log(error);
            });
    }

    setRenderData() {
        this.setState({ render: true });
        (this.state.companyInfo.country !== 'US' ||
            this.state.displayDiversityInfoJson === true) &&
            this.state.displayFinacialInfoJson === true &&
            this.state.displayCommoditiesInfoJson === true ?
            this.setState({ readOnlySubmitBtn: false })
            : this.setState({ readOnlySubmitBtn: true })
    }

    // urlWithParams = (urlString, params = {}) => {
    //     var url = new URL(urlString);
    //     var searchParams = new URLSearchParams();
    //     Object.keys(params).forEach((key) => {
    //         searchParams.append(key, params[key]);
    //     });
    //     url.search = searchParams.toString();
    //     return url.toString();
    // }

    handleFormSubmit(e) {
        e.preventDefault();
        let prosSuppId = this.state.prosSuppId;
        var userData = { prosSuppId: prosSuppId, status: "ASC" };
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/updateSupplier", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization" : "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (response.status === "204") {
            } else return response.json();
        }).then(() => {
            window.scrollTo(0, 0);
            this.loadSupplierDetails(this.state.prosNumber);
        }).catch(error => {
            console.log(error);
        });
    }

    getHeaderComment = () => {
        let prosSuppId = this.state.prosSuppId;
        let commentType = "RC";
        if (this.state.companyInfo.status === 'N') {
            commentType = "NC";
        } else if (this.state.companyInfo.status === 'H') {
            commentType = "HC";
        }
        let url = baseurl.COMMENT_API_URL + "comment/getCommentsByType/" + prosSuppId + "/" + commentType;
        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization" : "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (response.status === "500" || response.status === "204") {
                this.getParamComment();
            } else return response.json();
        }).then(data => {
            if (data !== undefined && data !== null) {
                this.setState({ headerComment: data.comment });
            }
            if (this.state.headerComment === "") {
                this.getParamComment();
            }
        }).catch(error => {
            console.log(error);
        });
    }

    getParamComment = () => {
        let jsonData = "APRV_CMNT";
        if (this.state.companyInfo.status === 'D') {
            jsonData = "SANC_F_CMNT";
        }
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParamsByCategory/categoryCd/localecd?categoryId=" + jsonData + "&localeCd=en_US", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization" : "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
            if (data[0] !== undefined && data[0] !== null) {
                this.setState({ headerComment: data[0].description });
            }
        }).catch(error => {
            console.log(error);
        });
    }
    render() {
        return (
            <div>
                {this.state.render === true ?
                    <div>
                        <Header pageHeading="Prospective Supplier" />
                        <div className="container-fluid bg-light">
                            <Container className="bg-light">
                                <br />
                                <div className="row">
                                    <span className="col-sm-24">
                                        <span style={{ textAlign: 'center' }}><h3>John Deere Prospective Supplier Application Form</h3></span>
                                        <CompanyStatus status={this.state.companyInfo.status} headerComment={this.state.headerComment} deereView={false}/>
                                        <Card>
                                            <div className="card-body">
                                                {this.state.isSupplierServiceDown ?
                                                    <div><ServiceDownError /></div>
                                                    :
                                                    <CompanyTopHeader companyInfoObj={this.state.companyInfo} deereView={false} />
                                                }
                                            </div>
                                        </Card>
                                    </span>
                                </div>
                                {this.state.companyInfo.country === "US" ?
                                    <div className="row">
                                        <span className="col-sm-8">
                                            {this.state.isDiversityServiceDown ?
                                                <div>
                                                    <h3 className="component-section-title">Supplier Diversity</h3>
                                                    <ServiceDownError />
                                                </div>
                                                :
                                                <DiversityComponent displayDiversityInfo={this.state.displayDiversityInfoJson} diversityInfo={this.state.diversityInfoJson} companyInfoObj={this.state.companyInfo} />
                                            }
                                        </span>
                                        <span className="col-sm-16">
                                            {this.state.isFinancialServiceDown ?
                                                <div>
                                                    <h3 className="component-section-title">Financial Information</h3>
                                                    <ServiceDownError />
                                                </div>
                                                :
                                                <FinacialComponent displayFinacialInfo={this.state.displayFinacialInfoJson} finacialInfo={this.state.finacialInfoJson} companyInfoObj={this.state.companyInfo} />
                                            }
                                        </span>
                                    </div>
                                    :
                                    <div className="row">
                                        <span className="col-sm-24">
                                            {this.state.isFinancialServiceDown ?
                                                <div>
                                                    <h3 className="component-section-title">Financial Information</h3>
                                                    <ServiceDownError />
                                                </div>
                                                :
                                                <FinacialComponent displayFinacialInfo={this.state.displayFinacialInfoJson} finacialInfo={this.state.finacialInfoJson} companyInfoObj={this.state.companyInfo} />
                                            }
                                        </span>
                                    </div>
                                }
                                <div className="row">
                                    <span className="col-sm-24">
                                        {this.state.isCommodityServiceDown ?
                                            <div>
                                                <h3 className="component-section-title">Commodities and Services</h3>
                                                <ServiceDownError />
                                            </div>
                                            :
                                            <CommoditiesComponent displayCommoditiesInfo={this.state.displayCommoditiesInfoJson} commoditiesInfo={this.state.commoditiesInfoJson} companyInfoObj={this.state.companyInfo} />
                                        }
                                    </span>
                                </div>
                                <br/>
                                {(this.state.companyInfo.status === 'ASI') &&
                                    (this.state.companyInfo.userRole !== undefined && this.state.companyInfo.userRole !== null && this.state.companyInfo.userRole !== "VIEW_ONLY") ?
                                    <div>
                                        <div className="row">
                                            <div className="col-sm-24" style={{ textAlign: 'right' }}>
                                                <Button disabled={this.state.readOnlySubmitBtn} action={this.handleFormSubmit} type="primary" title="Submit" />{" "}
                                            </div>
                                        </div>
                                        <br/>
                                    </div>
                                    : ""
                                }
                            </Container>
                        </div>
                        <Footer />
                    </div>
                    : ""
                }
            </div>
        );
    }
}
export default SupplierApplicationForm;